<template>
  <div class="container">
    <div class="container-side scroll">
      <Sidebar
        :menus="menus"
        :component="component"
        :parent="parent"
        @change="handleChange"
      />
    </div>
    <div class="container-component">
      <component :is="currentComponent" />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/experimentation/sidebar.vue'
import constructionknowledge from './components/construction/knowledge.vue'
import constructionthinking from './components/construction/thinking.vue'
import roofknowledge from './components/roof/knowledge.vue'
import roofthinking from './components/roof/thinking.vue'
import frameworkknowledge from './components/framework/knowledge.vue'
import frameworkthinking from './components/framework/thinking.vue'
import wallknowledge from './components/wall/knowledge.vue'
import wallthinking from './components/wall/thinking.vue'
import groundknowledge from './components/ground/knowledge.vue'
import groundthinking from './components/ground/thinking.vue'
export default {
  components: {
    Sidebar,
    constructionknowledge,
    constructionthinking,
    roofknowledge,
    roofthinking,
    groundknowledge,
    groundthinking,
    wallknowledge,
    wallthinking,
    frameworkknowledge,
    frameworkthinking,
  },
  data() {
    return {
      menus: [
        {
          label: 'lang.title.闽南侨乡传统建筑构造',
          value: 21,
          parent: 0,
          children: [
            {
              label: 'lang.mz.one.zs',
              value: 1,
              parent: 21,
              component: constructionknowledge,
            },
            {
              label: 'lang.mz.one.wt',
              value: 2,
              parent: 21,
              component: constructionthinking,
            },
            {
              label: 'lang.ct.one.jh',
              value: 3,
              parent: 21,
              path: '/experimentation/experimentation2/InteractiveAll',
            },
          ],
        },
        {
          label: 'lang.title.各部位做法工序',
          value: 4,
          parent: 0,
          children: [
            {
              label: 'lang.title.传统屋面',
              value: 5,
              parent: 4,
              children: [
                {
                  label: 'lang.mz.one.zs',
                  value: 6,
                  parent: 5,
                  component: roofknowledge,
                },
                {
                  label: 'lang.mz.one.wt',
                  value: 7,
                  parent: 5,
                  component: roofthinking,
                },
                {
                  label: 'lang.ct.one.jh',
                  value: 8,
                  parent: 5,
                  path: '/experimentation/experimentation2/InteractiveRoof',
                },
              ],
            },
            {
              label: 'lang.title.传统木架构',
              value: 9,
              parent: 4,
              children: [
                {
                  label: 'lang.mz.one.zs',
                  value: 10,
                  parent: 9,
                  component: frameworkknowledge,
                },
                {
                  label: 'lang.mz.one.wt',
                  value: 11,
                  parent: 9,
                  component: frameworkthinking,
                },
                {
                  label: 'lang.ct.one.jh',
                  value: 12,
                  parent: 9,
                  path: '/experimentation/experimentation2/InteractiveFramework',
                },
              ],
            },
            {
              label: 'lang.title.传统墙体',
              value: 13,
              parent: 4,
              children: [
                {
                  label: 'lang.mz.one.zs',
                  value: 14,
                  parent: 13,
                  component: wallknowledge,
                },
                {
                  label: 'lang.mz.one.wt',
                  value: 15,
                  parent: 13,
                  component: wallthinking,
                },
                {
                  label: 'lang.ct.one.jh',
                  value: 16,
                  parent: 13,
                  path: '/experimentation/experimentation2/InteractiveWall',
                },
              ],
            },
            {
              label: 'lang.title.传统地面',
              value: 17,
              parent: 4,
              children: [
                {
                  label: 'lang.mz.one.zs',
                  value: 18,
                  parent: 17,
                  component: groundknowledge,
                },
                {
                  label: 'lang.mz.one.wt',
                  value: 19,
                  parent: 17,
                  component: groundthinking,
                },
                {
                  label: 'lang.ct.one.jh',
                  value: 20,
                  parent: 17,
                  path: '/experimentation/experimentation2/InteractiveGround',
                },
              ],
            },
          ],
        },
      ],
      component: 1,
      currentComponent: constructionknowledge,
      parent: null,
    }
  },
  methods: {
    handleChange(val) {
      if (val.children) {
        this.parent = val.value
      } else {
        this.parent = val.parent
        this.component = val.value
        if (val.component) {
          this.currentComponent = val.component
        } else {
          this.$router.push(val.path)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: calc(90vh - 100px);
  display: flex;
  &-side {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 24px;
    padding: 0 7.5em 0 3vw;
  }
  &-component {
    height: 100%;
    flex: 1;
    padding-right: 3vw;
    padding-bottom: 5vh;
    ::v-deep {
      .main {
        width: 100%;
        height: 100%;
        padding: 3px;
      }
    }
  }
}
.scroll {
  overflow-x: hidden;
}
</style>